import { defineMessages } from 'react-intl';
export const messages = defineMessages({
  giftsTitle: {
    id: 'checkout.cartPage.gifts.title',
    defaultMessage: 'Choose your free gift',
  },
  chooseOne: {
    id: 'checkout.cartPage.gifts.chooseOne',
    defaultMessage: 'Choose your gift',
  },
  chooseMore: {
    id: 'checkout.cartPage.gifts.chooseMore',
    defaultMessage: 'Choose your gifts',
  },
  selectOne: {
    id: 'checkout.cartPage.gifts.selectOne',
    defaultMessage: 'Select your gift.',
  },
  selectMore: {
    id: 'checkout.cartPage.gifts.selectMore',
    defaultMessage: 'Select your gifts.',
  },
  chooseOneSample: {
    id: 'checkout.cartPage.gifts.chooseOne.sample',
    defaultMessage: 'Choose a free sample',
  },
  chooseMoreSample: {
    id: 'checkout.cartPage.gifts.chooseMore.sample',
    defaultMessage: 'Choose your free samples',
  },
  selectOneSample: {
    id: 'checkout.cartPage.gifts.selectOne.sample',
    defaultMessage: 'Select your free sample',
  },
  selectMoreSample: {
    id: 'checkout.cartPage.selectMore.sample',
    defaultMessage: 'Select your free samples',
  },
});
